import React from 'react';
import PropTypes from 'prop-types';

import CertificationBadge from 'components/CertificationBadge';

const BadgeEditorPreview = ({ iconName, foregroundColor, backgroundColor }) => {
  return (
    <div className="d-f jc-e f-1">
      <div className="fd-c">
        <div className="lh-24 c-brand-gray-darker">{t('common.preview')}</div>
        <div className="d-f bg-white pt-12 pb-12 pl-32 pr-32">
          <CertificationBadge
            iconName={iconName}
            foregroundColor={foregroundColor}
            backgroundColor={backgroundColor}
          />
        </div>
      </div>
    </div>
  );
};

BadgeEditorPreview.propTypes = {
  iconName: PropTypes.string,
  foregroundColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default BadgeEditorPreview;
